import {ModuleWithProviders, NgModule, Optional, Provider, SkipSelf} from "@angular/core";
import {BrowserModule} from "@angular/platform-browser";
import {BootstrapModalModule} from "../bootstrap-modal/bootstrap-modal.module";
import {FormsModule} from "@angular/forms";
import {ErrorModule} from "../errors/error.module";
import {MdProgressSpinnerModule} from "../misc/progress-spinner";
import {HttpClientModule} from "@angular/common/http";
import {SelectPrivilegeViewComponent} from "./select-privilege-view.component";
import {PrivilegeViewService} from "./privilege-view.service";
import { AppSettingsModule } from "../app-settings/app-settings.module";

@NgModule({
  imports: [
    BrowserModule,
    BootstrapModalModule,
    ErrorModule,
    FormsModule,
    MdProgressSpinnerModule,
    HttpClientModule,
    AppSettingsModule,
  ],
  declarations: [
    SelectPrivilegeViewComponent,
  ],
  providers: [
    PrivilegeViewService,
  ],
  exports: [
    SelectPrivilegeViewComponent,
  ],
})
export class PrivilegeViewModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: PrivilegeViewModule,
      providers: [
        {provide: PrivilegeViewService} as Provider,
      ],
    };
  }

  constructor(@Optional() @SkipSelf() parentModule: PrivilegeViewModule) {
    if (parentModule) {
      throw new Error("PrivilegeViewModule is already loaded. Import it in the main module only.");
    }
  }
}
